<div class="page-profile">
    <div class="container container-page-profile">

        <!-- Saludo. En móvil solo se ve en la raíz del perfil, que es donde
             vive el menú; dentro de una sección manda el título de la sección. -->
        <h1 class="greeting" *ngIf="showMenu">{{ greeting }}</h1>

        <!-- Cabecera de vuelta al menú, solo en móvil dentro de una sección.
             La entrada no la lleva: ya tiene su propio "← Mis entradas". -->
        <div class="back-to-menu" *ngIf="isMobile && !showMenu && !fullWidth" (click)="backToMenu()">
            <i class="fa-light fa-arrow-left"></i>
            <p class="m-0">Mi cuenta</p>
        </div>

        <div class="menu-profile" [class.full-width]="fullWidth">

            <!-- ===== RAIL =====
                 Una sola lista para escritorio y móvil: antes había dos
                 bloques calcados y cualquier alta o baja había que hacerla
                 en los dos. -->
            <nav class="rail" aria-label="Secciones de mi cuenta" [class.d-none]="!showMenu" *ngIf="!fullWidth">
                <ng-container *ngFor="let group of menuGroups">
                    <p class="rail-group">{{ group.title }}</p>
                    <a class="rail-option"
                       *ngFor="let option of group.options"
                       [routerLink]="option.link"
                       routerLinkActive="active">
                        <i class="rail-icon fa-light" [ngClass]="option.icon"></i>
                        <span class="rail-label">{{ option.label }}</span>
                        <span class="rail-badge" *ngIf="option.badge && counts[option.badge]">
                            {{ counts[option.badge] }}
                        </span>
                        <i class="rail-chevron fa-light fa-chevron-right" *ngIf="!option.badge || !counts[option.badge]"></i>
                    </a>
                </ng-container>

                <!-- Solo para gestores y solo por debajo de 1200px, que es
                     donde no se ve el selector "Usuario / Gestor" de la
                     cabecera (ver el scss). -->
                <button type="button" class="rail-option rail-panel" *ngIf="esGestor" (click)="irAlPanel()">
                    <i class="rail-icon fa-light fa-building"></i>
                    <span class="rail-label">Ir al panel de gestor</span>
                    <i class="rail-chevron fa-light fa-chevron-right"></i>
                </button>

                <button type="button" class="rail-option rail-logout" (click)="logout()">
                    <i class="rail-icon fa-light fa-arrow-right-from-bracket"></i>
                    <span class="rail-label">Cerrar sesión</span>
                </button>
            </nav>

            <div class="section-selected" [class.d-none]="isMobile && showMenu">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
